module.exports = __webpack_public_path__ + "img/202103.3a9ac245.png";